import { AnimatedSprites } from './AnimatedSprites';

export class FlavorText extends AnimatedSprites {
    constructor(scale: number) {
        const assets = PIXI.utils.TextureCache;
        const frames = [
            assets['fx/flavorTextVFX0001'],
            assets['fx/flavorTextVFX0002'],
            assets['fx/flavorTextVFX0003'],
            assets['fx/flavorTextVFX0004'],
            assets['fx/flavorTextVFX0005'],
            assets['fx/flavorTextVFX0006'],
            assets['fx/flavorTextVFX0007'],
            assets['fx/flavorTextVFX0008'],
            assets['fx/flavorTextVFX0009'],
            assets['fx/flavorTextVFX0010'],
            assets['fx/flavorTextVFX0011'],
            assets['fx/flavorTextVFX0012'],
            assets['fx/flavorTextVFX0013'],
            assets['fx/flavorTextVFX0014'],
        ];
        super(scale, frames);
    }
}
